import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'newLine' })
export class NewLinePipe implements PipeTransform {
  transform(value) {
    value.replace(/\n/g, '<br \/>');
    if (value.indexOf("<code>") !== -1) {
      let startIndex = value.indexOf("<code>") + 9;
      let endIndex = value.indexOf("</code>");
      let codeValue = value.slice(startIndex, endIndex);
      value.replace(/(<code>(.*?)<\/code>)/, codeValue);
    }
    return value;
  }
}



// WEBPACK FOOTER //
// /Users/danielcodrea/personal/Projects/HOW-TO_Project/how-to/src/app/pipes.ts